import { gql } from "@apollo/client";

export const SEARCH_USERS_QUERY = gql`
  query SearchUsers($searchTerm: String!) {
    searchUsers(searchTerm: $searchTerm) {
      id
      name
      isDoctor
      disabled
      color
    }
  }
`;

